import gql from 'graphql-tag';

import { createUseLazyQuery } from 'app/graphql/apolloFactoryHelpers';
import { CheckSymonConnectivity, CheckSymonConnectivityVariables } from 'app/graphql/generated/graphqlApolloTypes';

export const CHECK_SYMON_CONNECTIVITY = gql`
  query CheckSymonConnectivity($input: checkSymonConnectivityInput) {
    checkSymonConnectivity(input: $input)
  }
`;

export const useCheckSymonConnectivityLazy = createUseLazyQuery<
  CheckSymonConnectivity,
  CheckSymonConnectivityVariables
>(CHECK_SYMON_CONNECTIVITY);
